import { V_URL_API } from "../../../utils/config";

/**
 * Servicio para obtener la informacion mostrada cuando un curso no esta comprado
 *
 * @returns {Promise<Response>} - Respuesta de la API con toda la informacion del curso.
 * @throws {Error} - Lanza un error si la petición falla.
 */
export async function getCursoData(vCursoId) {
  const requestOptions = {
    method: "GET",
    redirect: "follow",
  };

  return await fetch(`${V_URL_API}/api/cursos/${vCursoId}`, requestOptions);
}
